import { Component, OnInit, inject } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { PageTitleService } from '../../core/services/page-title.service';
import { StudioService } from '../../core/services/studio.service';

@Component({
    selector: 'app-studio-plan',
    imports: [RouterLink],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-edit"></i>&nbsp;編集</span>
        </div>
        <div class="card-body">
          <div class="col-md-12">
            <div class="form-group row">
              <div class="col-md-6">
                <table class="table-bordered table-sm">
                  <thead>
                    <tr><th width="50%">表示ID</th><th width="50%">店舗名</th></tr>
                  </thead>
                  <tbody>
                    <tr><td>{{studio.sortBy}}</td><td>{{studio.name}}</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          @if (!alertDismissed) {
          <div class="col-md-12">
            <div class="alert alert-danger" role="alert">
              <button type="button" class="close" (click)="alertDismissed = true" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <p>区分コースを削除する場合は、会員のコース区分で使用されていないことを事前に確認してください。(システム内部では削除前のチェックは行っていません)</p>
            </div>
          </div>
          }
          <div class="col-md-12">
            <a class="btn btn-primary text-white" [routerLink]="['/studio', studioId, 'plan', 'new']"><i class="fa s-icon-plus fa-fw"></i>&nbsp;新規作成</a>
          </div>
        </div>
        <div class="card-body">
          <div class="col-md-12">
            @if (loading) {
              <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
            }
            @if (!loading && plans.length === 0) {
              <span>該当するデータはありません</span>
            }
            @if (plans.length > 0) {
              <table class="table table-bordered table-sm table-hover table-ptb-0">
                <thead>
                  <tr>
                    <th>状態</th>
                    <th>コース名</th>
                    <th>コースタイプ</th>
                    <th>利用時間</th>
                    <th>月会費(初月)</th>
                    <th>月会費(2ヶ月目)</th>
                    <th>月会費(3～12ヶ月目)</th>
                    <th>月会費(通常)</th>
                    <th>入会金・事務手数料</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (plan of plans; track plan.id) {
                    <tr>
                      <td class="text-center">
                        @if (plan.noShowAvailable == 0) {
                          <button type="button" class="btn text-secondary bg-inherit p-0 active" (click)="enableWebShow(plan)"><i class="fa fa-3x fa-toggle-off"></i></button>
                        }
                        @if (plan.noShowAvailable == 1) {
                          <button type="button" class="btn text-green p-0 bg-inherit active" (click)="disableWebShow(plan)"><i class="fa fa-3x fa-toggle-on"></i></button>
                        }
                      </td>
                      <td>{{plan.name}}</td>
                      <td>{{plan.studioPlanType?.name}}</td>
                      <td>{{plan.time}}</td>
                      <td>
                        @if (plan.firstMonthProduct == null) {
                          <span class="pull-right">{{currencyJpy(plan.firstMonthFee)}}</span>
                        }
                        @if (plan.firstMonthProduct != null) {
                          <span class="pull-right">{{currencyJpy(plan.firstMonthProduct.amount)}}</span>
                        }
                      </td>
                      <td>
                        @if (plan.secondMonthProduct == null) {
                          <span class="pull-right">{{currencyJpy(plan.secondMonthFee)}}</span>
                        }
                        @if (plan.secondMonthProduct != null) {
                          <span class="pull-right">{{currencyJpy(plan.secondMonthProduct.amount)}}</span>
                        }
                      </td>
                      <td>
                        @if (plan.studioPlanIndividuals?.length === 0) {
                          <span>設定なし</span>
                        }
                        @if (plan.studioPlanIndividuals?.length > 0) {
                          <a href="" (click)="openIndividualModal(plan); $event.preventDefault()">設定あり</a>
                        }
                      </td>
                      <td>
                        @if (plan.monthlyProduct == null) {
                          <span class="pull-right">{{currencyJpy(plan.monthlyFee)}}</span>
                        }
                        @if (plan.monthlyProduct != null) {
                          <span class="pull-right">{{currencyJpy(plan.monthlyProduct.amount)}}</span>
                        }
                      </td>
                      <td>
                        @if (plan.studioKeyProduct == null) {
                          @if (plan.freeKeyOption == 0) { <span>無料</span> }
                          @if (plan.freeKeyOption == 1) { <span>有料</span> }
                        }
                        @if (plan.studioKeyProduct != null) {
                          <span class="pull-right">{{currencyJpy(plan.studioKeyProduct.amount)}}</span>
                        }
                      </td>
                      <td class="text-center">
                        <a class="mt-1 mb-1 btn btn-primary btn-sm text-white"
                          [routerLink]="['/studio', studioId, 'plan', plan.id, 'edit']" title="編集">
                          <i class="fa s-icon-edit fa-fw"></i>
                        </a>
                        @if (plan.noShowAvailable == 0) {
                          <button type="button" class="mt-1 mb-1 btn btn-danger btn-sm" (click)="openDeleteModal(plan)" title="削除">
                            <i class="fa s-icon-delete fa-fw"></i>
                          </button>
                        }
                        @if (plan.noShowAvailable == 1) {
                          <button type="button" class="mt-1 mb-1 btn btn-secondary btn-sm text-white" disabled title="削除">
                            <i class="fa s-icon-delete fa-fw"></i>
                          </button>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (individualModal) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{individualModal.name}}&nbsp;月会費(3～12ヶ月目)</h5>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <table class="table table-sm table-borderless">
              @for (item of individualModal.studioPlanIndividuals; track $index) {
                <tr>
                  <th class="text-right" style="width: 40%;">{{$index + 3}}ヶ月目：</th>
                  <td>{{item.product?.name}}&nbsp;{{currencyJpy(item.product?.amount)}}</td>
                </tr>
              }
              @if (individualModal.studioPlanIndividuals?.length < 10) {
                <tr>
                  <th class="text-right" style="width: 40%;">
                    @if (individualModal.studioPlanIndividuals?.length != 9) {
                      <span>{{individualModal.studioPlanIndividuals?.length + 3}}ヶ月目~</span>
                    }
                    12ヶ月目：
                  </th>
                  <td>通常料金</td>
                </tr>
              }
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="individualModal = null">
            <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
          </button>
        </div>
      </div>
    </div>
  </div>
}

@if (deleteModal) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content border-danger">
        <div class="modal-header bg-danger">
          <h5 class="modal-title">区分コースの削除</h5>
          <button type="button" class="close" (click)="deleteModal = null">
            <span class="text-white" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="background-color: #FFF6F8 !important">
          <div class="form-group row">
            <label class="col-md-12 col-form-label">区分コースを削除します。よろしいですか。</label>
          </div>
        </div>
        <div class="modal-footer" style="background-color: #FFF6F8 !important">
          <button class="btn bg-close text-white" type="button" (click)="deleteModal = null">
            <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
          </button>
          <button class="btn btn-danger" type="button" (click)="removePlan()">
            <i class="fa s-icon-delete"></i>&nbsp;削除
          </button>
        </div>
      </div>
    </div>
  </div>
}
  `
})
export class StudioPlanComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private studioService = inject(StudioService);
  private route = inject(ActivatedRoute);

  studioId!: number;
  studio: any = {};
  plans: any[] = [];
  loading = true;
  alertDismissed = false;
  individualModal: any = null;
  deleteModal: any = null;

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('店舗管理', 's-icon-studio');
    this.studioId = +this.route.snapshot.params['studioId'];
    await this.loadData();
  }

  private async loadData(): Promise<void> {
    this.loading = true;
    try {
      const data: any = await this.studioService.list(this.studioId);
      this.studio = Array.isArray(data) ? (data[0] ?? {}) : (data ?? {});
      this.plans = this.studio.studioPlans ?? this.studio.studioPlan ?? this.studio.plans ?? [];
    } finally {
      this.loading = false;
    }
  }

  currencyJpy(amount: any): string {
    if (amount == null) return '';
    return '¥' + Number(amount).toLocaleString('ja-JP', { maximumFractionDigits: 0 });
  }

  openIndividualModal(plan: any): void {
    this.individualModal = plan;
  }

  openDeleteModal(plan: any): void {
    this.deleteModal = plan;
  }

  async enableWebShow(plan: any): Promise<void> {
    await this.studioService.upsertStudioPlan({ id: plan.id, noShowAvailable: 1 });
    plan.noShowAvailable = 1;
  }

  async disableWebShow(plan: any): Promise<void> {
    await this.studioService.upsertStudioPlan({ id: plan.id, noShowAvailable: 0 });
    plan.noShowAvailable = 0;
  }

  async removePlan(): Promise<void> {
    if (!this.deleteModal) return;
    await this.studioService.removeStudioPlan(this.deleteModal.id);
    this.deleteModal = null;
    await this.loadData();
  }
}
